import { redirectToHomeIfNotAdmin } from '@/data-integrations/router/guards';

const FileCleanerPage = () => import('@/file-cleaner/pages/file-cleaner-page.vue');

export const fileCleanerRoutes = [
  {
    path: '/file-cleaner',
    name: 'file-cleaner',
    component: FileCleanerPage,
    beforeEnter: redirectToHomeIfNotAdmin,
    meta: {
      layout: 'layout-empty',
    },
  },
];
